import moment from 'moment'
export default {
  formatDate(str) {
    return moment(str).format("YYYY-MM-DD HH:mm:ss");
  },
    //手机号加星
    addStarToString(str){
        if(typeof str == "string") {
            let tmp = str.split("");
            let changeIndex = parseInt(tmp.length / 2);
            _.forEach(tmp, (v, k) => {
                if(k == changeIndex - 2 || k == changeIndex - 1 || k == changeIndex || k == changeIndex + 1 ){
                    tmp[k] = "*";
                }
            })
            return tmp.join("");
        }else{
            return "";
        }

    },
    getFirstTag(str="") {
      if (typeof str === "string") {
        if (str.split(";").length > 1) {
          return str.split(";")[0]
        }
      }
    },

};



// WEBPACK FOOTER //
// ./src/libs/filters.js